import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportesService } from '@reportes/reportes.service';
import { VisorInformeResolucionComponent } from '../visor-informe-resolucion/visor-informe-resolucion.component';
import { MessageService } from '@shell/message.service';

@Component({
  selector: 'app-modal-generar-resolucion',
  templateUrl: './modal-generar-resolucion.component.html',
  styleUrls: ['./modal-generar-resolucion.component.scss']
})
export class ModalGenerarResolucionComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    public modal: NgbModal,
    private reportesService: ReportesService, 
    private messageService: MessageService) {
  }

  codigoAeroplanta: string;
  fdesde: string;
  fhasta: string;
  productos;
  esTercera: boolean;
  grabando: boolean = false;

  ngOnInit() {
    console.log("productos: ", this.productos);
  }

  generarInforme() {
    const nombreResolucion = (this.esTercera) ? 'TERCERAS' : this.codigoAeroplanta;
    this.grabando = true;
    this.reportesService.guardarResolucionMensual(this.codigoAeroplanta, this.fdesde, this.fhasta).subscribe(res => {
      const modalRef = this.modal.open(VisorInformeResolucionComponent, { centered: true, size: 'xl', backdrop: 'static', keyboard: false });
      const resolucion = res[0];
      
      if(this.esTercera) {
        resolucion.renglonesResolucion = [];
        const resolucionArray = res;
        resolucionArray.forEach(res => {
          resolucion.renglonesResolucion = resolucion.renglonesResolucion.concat(res.renglonesResolucion);
        })
      }
      
      for (const item of resolucion.renglonesResolucion) {
        item.porcentual = item.porcentual ? item.porcentual : 0;
        item.nombreProducto = this.productos.find(p=>p.codigoProducto==item.codigoProducto).nombreProducto;
      }
      resolucion.renglonesResolucion.sort((a, b) => {
        if (a.codigoAeroplanta < b.codigoAeroplanta) {
          return -1;
        } else if (a.codigoAeroplanta > b.codigoAeroplanta) {
          return 1;
        } else {
          return a.nombreProducto.localeCompare(b.nombreProducto);
        }
      });
      modalRef.componentInstance.resoluciones = resolucion;
      modalRef.componentInstance.fileName = `Resolución_${nombreResolucion}_${res[0].mes}/${res[0].ano}.pdf`
      modalRef.componentInstance.esTercera = nombreResolucion == 'TERCERAS' ? true : false;
      this.grabando = false;
      modalRef.result.then(() => {
        this.activeModal.close(false);
      });
      }, (error) => {
        this.grabando = false;
        this.messageService.showErrorMessage(error.description);
        this.activeModal.close(false);
      })
  }

  
}
